import type { ValueFormat } from '@components/Setting/SettingProcessorConfigField';

export type Setting = {
  id: string;
  updatedAt: string;
  createdAt: string;
  slug: string;
  title: string;
  description: string;
  setting: {
    type: string;
    value: string | number | boolean | object | ValueFormat;
    metadata?: Record<string, unknown>;
  };
  isSensitive: boolean;
  isDeleted: boolean;
  status: (typeof SettingStatus)[keyof typeof SettingStatus];
  activeFrom: Date | undefined;
  createdBy: string;
};

export const SettingStatus = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  SCHEDULED: 'scheduled',
} as const;

export const valueTypeOptions = [
  { value: 'string', label: 'String' },
  { value: 'number', label: 'Number' },
  { value: 'boolean', label: 'Boolean' },
  { value: 'date', label: 'Date' },
  { value: 'json', label: 'JSON' },
  { value: 'array', label: 'Array' },
];

export type SettingPayload = Omit<
  Setting,
  'id' | 'createdAt' | 'updatedAt' | 'createdBy' | 'isDeleted'
>;

export type SettingUpdatePayload = Pick<SettingPayload, 'setting' | 'activeFrom'>;
